export function prettyStepNames(stepId) {
  return stepId
    .replace(/_/g, ' ')
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

export function isAgentOutputValid(output) {
  try {
    const json = JSON.parse(output);
    if (json.answer || json.answer_list) {
      return true;
    }
    return false;
  } catch (error) {
    return false;
  }
}

function cleanOutput(raw) {
  // 1) Trim wrapper noise (backticks, BOM, zero-width, NBSP)
  let s = String(raw).trim();
  if (s.startsWith('`') && s.endsWith('`')) s = s.slice(1, -1);
  s = s
    .replace(/^\uFEFF/, '')
    .replace(/[\u200B-\u200D\u2060\u00A0]/g, '')
    .replace(/\r\n?/g, '\n');

  // 2) Parse the outer JSON
  const outer = JSON.parse(s);

  // 3) Normalize: each element currently looks like { "<question>": "<json string>" }
  const normalized = {
    id: outer.id,
    answer: (outer.answer || outer.answer_list).map((entry) => {
      const [[question, responseStr]] = Object.entries(entry);

      // 4) Try to parse the inner JSON string safely
      let response;
      try {
        response = JSON.parse(responseStr);
      } catch {
        // common unescapes if the inner JSON was double-escaped or messy
        const unescaped = responseStr.replace(/\\n/g, '\n').replace(/\\"/g, '"').replace(/\\\\/g, '\\').trim();
        try {
          response = JSON.parse(unescaped);
        } catch {
          // Last resort: keep raw string
          response = responseStr;
        }
      }

      return { question, response };
    }),
  };

  return normalized;
}

export function cleanOutputToString(raw, space = 2) {
  return JSON.stringify(cleanOutput(raw), null, space);
}

export function formatAgentOutput(output) {
  try {
    return JSON.parse(cleanOutputToString(output));
  } catch (error) {
    console.error('error', error);
    return 'Invalid output';
  }
}

export function parseAgentOutput(output) {
  if (isAgentOutputValid(output)) {
    return JSON.parse(output);
  }
  return output;
}
